import React, { memo } from "react";
import { Button, Col, Row } from "antd";
import { createUseStyles } from "react-jss";
import { useTranslation } from "react-i18next";
import LoadingView from "../../atoms/loadingView";
import { COLORS, useDateChange } from "core";
import { Text } from "../../atoms";

interface Props {
  title?: string;
  data?: any;
  onClick?: any;
  isLoading?: any;
 type?:any
}

const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  text: {
    marginBottom: "20px",
    color: colors.white,
  },
  member:{
    color: colors.white,
  },

  title: {
    marginBottom: "20px",
    fontWeight: "bolder",
    color: colors.white,
  },
  title2: {
    color: colors.white,
    fontWeight:'bold'
  },
}));

const Detail = memo<Props>(({ title, data, onClick, isLoading,type }) => {
  
  const classes = useStyle();
  const { i18n } = useTranslation();
  const { changeDateToPersian } = useDateChange();

  return (
    <LoadingView isLoading={isLoading}>
      <Col>
        <Row className={classes.title}>{title}</Row>
        {data?.[0]?.nameAndFamily && (
          <>
            <div className={classes.title2}>{i18n.t("nameAndFamily")}:</div>
            <Row className={classes.text}>{data?.[0]?.nameAndFamily}</Row>
          </>
        )}
        {data?.[0]?.userName && (
          <>
            <div className={classes.title2}>{i18n.t("userName")}:</div>
            <Row className={classes.text}>{data?.[0]?.userName}</Row>
          </>
        )}
        {data?.[0]?.mobileNumber && (
          <>
            <div className={classes.title2}>{i18n.t("mobileNumber")}:</div>
            <Row className={classes.text}>{data?.[0]?.mobileNumber}</Row>
          </>
        )}
         {data?.[0]?.category && (
          <>
            <div className={classes.title2}>{i18n.t("category")}:</div>
            <Row className={classes.text}>{data?.[0]?.category?.name}</Row>
          </>
        )}
         {data?.[0]?.administrator && (
          <>
            <div className={classes.title2}>{i18n.t("administrator")}:</div>
            <Row className={classes.text}>{data?.[0]?.administrator.nameAndFamily}</Row>
          </>
        )}
          {data?.[0]?.supervisor && (
          <>
            <div className={classes.title2}>{i18n.t("supervisor")}:</div>
            <Row className={classes.text}>{data?.[0]?.supervisor.nameAndFamily}</Row>
          </>
        )}
        {data?.[0]?.hallManager && (
          <>
            <div className={classes.title2}>{i18n.t("hallManager")}:</div>
            <Row className={classes.text}>{data?.[0]?.hallManager.nameAndFamily}</Row>
          </>
        )}
         {data?.[0]?.saleManager && (
          <>
            <div className={classes.title2}>{i18n.t("saleManager")}:</div>
            <Row className={classes.text}>{data?.[0]?.saleManager.nameAndFamily}</Row>
          </>
        )}
        {data?.[0]?.isArray && (
          <>
            <div className={classes.title2}>{i18n.t("isArray")}:</div>
            <Row className={classes.text}>{data?.[0]?.isArray}</Row>
          </>
        )}
        {data?.[0]?.access && (
          <>
            <div className={classes.title2}>{i18n.t("access")}:</div>
            <Row className={classes.text}>{data?.[0]?.access}</Row>
          </>
        )}
        {data?.[0]?.name && (
          <>
            <div className={classes.title2}>{i18n.t("name")}:</div>
            <Row className={classes.text}>{data?.[0]?.name}</Row>
          </>
        )}
        {data?.[0]?.created_at && (
          <>
            <div className={classes.title2}>{i18n.t("created_at")}:</div>
            <Row className={classes.text}>
              {changeDateToPersian(data?.[0]?.created_at)}
            </Row>
          </>
        )}
        {(data?.user1 || data?.role1) && (
          <>
            <div className={classes.title2}>{i18n.t("firstEntity")}:</div>
            <Row className={classes.text}>{data?.user1 || data?.role1}</Row>
          </>
        )}
        {data?.[0]?.updated_at && (
          <>
            <div className={classes.title2}>{i18n.t("updated_at")}:</div>
            <Row className={classes.text}>
              {changeDateToPersian(data?.[0]?.updated_at)}
            </Row>
          </>
        )}
        {data?.conversations?.[0]?.title && (
          <>
            <div className={classes.title2}>{i18n.t("name")}:</div>
            <Row className={classes.text}>
              {data?.conversations?.[0]?.title}
            </Row>
          </>
        )}
        {data?.conversations?.[0]?.mandatory && (
          <>
            <div className={classes.title2}>{i18n.t("mandatory")}:</div>
            <Row className={classes.text}>
              {data?.conversations?.[0]?.mandatory
                ? i18n.t("yes")
                : i18n.t("no")}
            </Row>
          </>
        )}
        {data?.conversations?.[0]?.updated_at && (
          <>
            <div className={classes.title2}>{i18n.t("updated_at")}:</div>
            <Row className={classes.text}>
              {changeDateToPersian(data?.conversations?.[0]?.updated_at)}
            </Row>
          </>
        )}
        {data?.conversations?.[0]?.created_at && (
          <>
            <div className={classes.title2}>{i18n.t("created_at")}:</div>
            <Row className={classes.text}>
              {changeDateToPersian(data?.conversations?.[0]?.created_at)}
            </Row>
          </>
        )}
        {type==="channel"&&
        <>
         <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("admins")}:</div>
            {data?.conversations?.[0]?.admins?.map((item:any)=>{return <Row className={classes.member}>{ item?.name_and_family}</Row>})}
            <br/>
          <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("members")}:</div>
            {data?.conversations?.[0]?.participants?.map((item:any)=>{return <Row className={classes.member}>{ item?.user?.name_and_family }</Row>})}
            <br/>
          <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("administrator")}:</div>
            {<Row className={classes.member}>{data?.conversations?.[0]?.administrator?.name_and_family}</Row>}
            <br/>
          <div style={{marginBottom:'5px',marginTop:'30px'}} className={classes.title2}>{i18n.t("supervisor")}:</div>
            {<Row className={classes.member}>{data?.conversations?.[0]?.supervisor?.name_and_family}</Row>}

          <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("roles")}:</div>
            {data?.conversations?.[0]?.roles?.map((item:any)=>{return <Row className={classes.member}>{item?.name}</Row>})}
            <br/>
         </>
        }
         {type==="group"&&
        <>
         <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("admins")}:</div>
            {data?.conversations?.[0]?.admins?.map((item:any)=>{return <Row className={classes.member}>{ item?.name_and_family }</Row>})}
            <br/>
          <div style={{marginBottom:'5px'}} className={classes.title2}>{i18n.t("members")}:</div>
            {data?.conversations?.[0]?.participants?.map((item:any)=>{return <Row className={classes.member}>{ item?.user?.name_and_family}</Row>})}
         </>
        }
        <Row>
          <Button style={{marginTop:'20px'}} onClick={onClick}>{i18n.t("edit")}</Button>
        </Row>
      </Col>
    </LoadingView>
  );
});

export { Detail };
